import { type ThunkAction, type ThunkDispatch } from "@reduxjs/toolkit";

import { mixpanelAdminResolved } from "../../mixpanel/mixpanel";
import { type ReduxState } from "../../types/reduxState";
import { type ThunkExtraArgument } from "../../types/thunk";
import { type DashboardReducerAction } from "../reducers/dashboardReducer";
import { type ErrorReducerAction } from "../reducers/errorReducer";
import { addError } from "./addErrorAction";

type DashboardReducerThunkAction = ThunkAction<
  void,
  ReduxState,
  ThunkExtraArgument,
  DashboardReducerAction
>;

export type DashboardReducerDispatch = ThunkDispatch<
  ReduxState,
  ThunkExtraArgument,
  DashboardReducerAction | ErrorReducerAction
>;

export const onUserIdChange: (
  uid: string | null
) => DashboardReducerThunkAction = (uid: string | null) => {
  return (
    dispatch: DashboardReducerDispatch,
    getState: () => ReduxState,
    { userApi }: ThunkExtraArgument
  ) => {
    if (!uid) {
      dispatch({ type: "SET_ADMIN_FLAG", userIsAdmin: false });
      return;
    }
    userApi
      .isAdminUser(uid)
      .then((userIsAdmin) => {
        mixpanelAdminResolved(uid, userIsAdmin);
        dispatch({ type: "SET_ADMIN_FLAG", userIsAdmin });
      })
      .catch(addError(dispatch));
  };
};

export const setFeatureFlag: (
  featureFlag: keyof ReduxState["dashboardApp"]["featureFlags"],
  value: boolean
) => DashboardReducerAction = (
  featureFlag: keyof ReduxState["dashboardApp"]["featureFlags"],
  value: boolean
) => ({ type: "SET_FEATURE_FLAG", featureFlag, value });
